<h1>Änderungen in der TVöD Entgelttabelle</h1>
<p>
  Hier findest du die TVöD Entgelttabellen entsprechend der Tarifänderungen. Du kannst auch direkt dein Gehalt über den
  <a [routerLink]="['/gehalt/rechner']">Gehaltsrechner</a> berechnen.
</p>
<div class="list-group">
  @for(la of labourAgreements;track la.id){
  <a [routerLink]="['/tariftabellen', la.tvoed]" class="list-group-item list-group-item-action" aria-current="true">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <h5 class="mb-1">Gültig {{ la.name }}</h5>
      <span
        class="badge status-badge"
        [ngClass]="{ 'text-bg-success': la.status === TimeFrameStatus.WITHIN,'text-bg-secondary': la.status === TimeFrameStatus.PAST,'text-bg-info': la.status === TimeFrameStatus.UPCOMING, }"
      >
        {{ la.status }}
      </span>
    </div>
    <div class="d-flex w-100 justify-content-end">
      <small>Tarifabschluss vom {{ la.dealDate }}</small>
    </div>
    <div class="d-flex w-100 justify-content-end">
      <small>Laufzeit: {{ la.bargainingRound }}</small>
    </div>
    @if(la.info){
    <div class="d-flex w-100 mt-3">
      <small>{{ la.info }}</small>
    </div>
    }
  </a>
  }
</div>
